import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type Connection, type Workflow } from '@blaze-shared/workflow-domain';

export const updateChatWorkflows = createAction(
  '[Runtime][Chat] Update workflows',
  props<{
    elementId: CanvasElementId;
    workflows: Workflow[];
    connection?: Connection;
  }>(),
);

export const updateChatWorkflowsSuccess = createAction(
  '[Runtime][Chat] Update workflows success',
  props<{
    elementId: CanvasElementId;
    workflows: Workflow[];
    connection?: Connection;
  }>(),
);

export const updateChatWorkflowsFailure = createAction(
  '[Runtime][Chat] Update workflows failure',
  props<{
    elementId: CanvasElementId;
  }>(),
);
